import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';

import OnlineBooking from '../../../Images/Apps/OnlineBooking';

const OnlineBookingStrategy = {
  previewInfo: {
    name: 'Online booking',
    iconSvg: <OnlineBooking />,
    newTab: true,
  },
  headerInfo: {
    name: 'Online booking on your website',
    category: 'Online booking',
    details:
      'When you miss a phone call or forget to reply to an email, your potential customer might start looking elsewhere for a service provider. Put that money back in your pocket with Housecall Pro’s online booking app. Your booking site stays open even when your business is closed or you’re busy, so customers can easily book in seconds at a time that’s best for them.',
    iconSvg: (
      <OnlineBooking
        style={{
          maxHeight: 80,
          minWidth: 100,
          maxWidth: 200,
          height: '100%',
        }}
      />
    ),
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/dk39x6on73?autoPlay=false',
  },
  sellingPoints: {
    headline: 'Why use Online Booking?',
    description:
      'Housecall Pro’s Online Booking app is integrated directly into your schedule, making it easier than ever to win more jobs and stay organized. Your customers can quickly view your real-time availability and self-book their own appointments, without playing phone tag.',
  },
  price: {
    price: 'No referral fee',
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
};

export default OnlineBookingStrategy;
